import styled from "styled-components";

export const DocumentView = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing.xxx_small }px;

  & > button.file-info-view {
    display: flex;
    flex-direction: row;
    padding: ${({ theme }) => `${ theme.spacing.xx_small }px ${ theme.spacing.x_small }px`};
    background-color: ${({ theme }) => theme.colors.text.default }11;
    border-radius: ${({ theme }) => theme.border_radius.small }px;
    gap: ${({ theme }) => theme.spacing.xx_small }px;
    cursor: pointer;
    transition: all .2s;
    width: 100%;
    border: none;
    color: inherit;
    text-align: left;
  }

  & > button.file-info-view:hover {
    background-color: ${({ theme }) => theme.colors.text.default }33;
  }

  & > button.file-info-view > svg {
    min-width: 40px;
    max-width: 40px;
  }

  & > button.file-info-view > div.file-info {
    display: flex;
    flex-direction: column;
    justify-content: center;
    gap: ${({ theme }) => theme.spacing.xx_small }px;
    overflow: hidden;
  }

  & > button.file-info-view > div.file-info > span:first-of-type {
    min-height: ${({ theme }) => theme.font_size.xx_small }px;
    font-size: ${({ theme }) => theme.font_size.xx_small }px;
    line-height: ${({ theme }) => theme.font_size.xx_small }px;
    font-weight: 500;

    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }

  & > button.file-info-view > div.file-info > span:last-of-type {
    min-height: ${({ theme }) => theme.font_size.x_small }px;
    font-size: ${({ theme }) => theme.font_size.x_small }px;
    line-height: ${({ theme }) => theme.font_size.x_small }px;
    font-weight: 300;
  }
`;
